import { stringify } from 'querystring';

export const closureSetSelectedOption = (parsedQs, history, type, value) => () => {
  const newQueryString = {
    ...parsedQs,
    [type]: value,
  };

  history.replace(`?${stringify(newQueryString)}`);
};

export const getOffersQty = item => (item?.offers?.result ?? []).length;

export const getDiffs = diffs =>
  diffs ? diffs.reduce((tps, diff) => ({ ...tps, [diff.type.toLowerCase()]: diff.value }), {}) : {};

export const getSku = (product, currentSku, type, value) => {
  const skus = product?.skus ?? [];
  const types = Object.keys(currentSku?.qs || {});

  if (types.length > 1) {
    return skus.find(sku => {
      const diffs = getDiffs(sku.diffs);
      return diffs[type] === value && Object.keys(diffs).find(tp => type !== tp && diffs[tp] === currentSku.qs[tp]);
    });
  }
  return skus.find(sku => (sku?.diffs?.[0]?.value ?? '') === value);
};

export const getTextLabel = (typeId, typeValuesQty, isAvailableOffer) => {
  if (isAvailableOffer) {
    if (typeValuesQty === 1) {
      return `${typeId} disponível`;
    }

    const mapArticle = {
      cor: ' a ',
      sabor: ' o ',
      voltagem: ' a ',
      tamanho: ' o ',
      default: ' ',
    };
    const article = mapArticle[typeId] ?? mapArticle.default;
    return `escolha${article}${typeId}`;
  }

  return '';
};
